import React, { useEffect, useState } from 'react';
import styles from './EmployerPortalApplications.module.css';
import { GenderIcon, UserDummyImg, VerifyGreenBadge } from '../../../../assets/images/icons';
import { Typography } from '../../../Typography/typography';
import userAvatarPlaceholder from '../../../../assets/images/other/user_avatar_placeholder.png';
import Flag from 'react-flags';
import { t } from 'i18next';
import { CgGenderFemale } from "react-icons/cg";

function ApplicationsList({ applications, setApplicationDetail, selectedApplication }) {
    const [applicationsClone, setApplicationsClone] = useState(applications?.applications || []);

    useEffect(() => {
        if (applications?.applications) setApplicationsClone(applications?.applications.filter((e) => e?.jobseeker))
    }, [applications?.applications])
    return (
        <div className={styles.applicationsList}>
            <div className={styles.scrollableList}>
                {applicationsClone.map(app => {
                    const jobseeker = app?.jobseeker || null
                    return (
                        <div key={app?.application?.id}
                            className={selectedApplication?.application?.id == app?.application?.id ? styles.activeApplicationItem : styles.applicationItem}
                            onClick={() => setApplicationDetail(app)}
                        >
                            {jobseeker?.profile_image ?
                                <img
                                    src={process.env.REACT_APP_UPLOADS_PATH + jobseeker?.profile_image}
                                    alt={jobseeker?.profile_image}
                                    className={styles.userPhoto}
                                    onError={(e) => {
                                        e.target.onerror = null; // Prevent infinite loop
                                        e.target.src = userAvatarPlaceholder; // Set fallback image
                                    }} />

                                :
                                <img src={userAvatarPlaceholder}
                                    alt={jobseeker?.profile_image}
                                    className={styles.userPhoto} />
                            }
                            <div>
                                {jobseeker &&
                                    <div className={`${styles.namedWrapper}`}>
                                        <Typography fontSize={15} weight={600} color={'#093559'} title={(jobseeker?.first_name || '') + " " + (jobseeker?.last_name || '')} className={styles.userName} />
                                        {jobseeker.verification_status && <img src={VerifyGreenBadge} className={styles.verificationBadge} />}
                                    </div>
                                }
                                <div className={styles.flagContainer}>
                                    {jobseeker?.country &&
                                        <div>
                                            <Flag
                                                name={jobseeker?.country}
                                                format="svg"
                                                shiny={false}
                                                basePath="/vendor/flags"
                                            />
                                            <span title={t('general.country.' + jobseeker?.country)}>
                                                {t('general.country.' + jobseeker?.country)}
                                            </span>
                                        </div>
                                    }
                                    {jobseeker?.country && jobseeker?.gender && <div className={styles.saperatorGender}></div>}
                                    {jobseeker?.gender &&
                                        <div>
                                            {jobseeker?.gender.toLowerCase() === 'male' ? (
                                                <img src={GenderIcon} alt={`pasport icon`}
                                                    className={styles.icon}
                                                />
                                            ) : (
                                                <CgGenderFemale size={22} />
                                            )}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div >
    );
}

export default ApplicationsList;